import { Pipe, PipeTransform } from '@angular/core';
import { RmaIcons } from '@rma/generic/ui/icon';
import { SYNDICATION_CHANNELS_CONFIG } from '../domain/channel-config.model';
import { SyndicationChannel } from '../domain/syndication-channels.model';

@Pipe({
  name: 'channelIcon',
  standalone: true,
})
export class ChannelIconPipe implements PipeTransform {
  transform(value: SyndicationChannel, useBase = false): RmaIcons {
    const item = SYNDICATION_CHANNELS_CONFIG[value];

    return useBase ? item.baseIcon : item.icon;
  }
}
